import { callApi } from '../services/apiService';
import { responseHandler } from '../handler/responseHandler';

export const resumeUpload = {
  uploadResume: async (params = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'candidate/upload',
      params: params,
      isFile: true
    });
    return responseHandler(response);
  },

  addResume: async (params = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'recruiter/upload',
      params: params,
      isFile: true
    });
    return responseHandler(response);
  },


  resumeUpdate: async (params = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'candidate/resume_update',
      params: params,
      isFile: true
    });
    return responseHandler(response);
  },

  getCandidateDetails: async (params = {}, signal) => {
    const response = callApi({
      method: 'POST',
      endpoint: `candidate_resume`,
      params: params,
      isFile: false,
      signal
    });
    return responseHandler(response);
  },


    verifyProfile: async (params = {}, signal) => {
    const response = callApi({
      method: 'POST',
      endpoint: `verify_profile`,
      params: params,
      isFile: false,
      signal
    });
    return responseHandler(response);
  },

  getCandidateDetailsRecruiter: async (params = {}, signal) => {
    const response = callApi({
      method: 'POST',
      endpoint: `resume`,
      params: params,
      isFile: false,
      signal
    });
    return responseHandler(response);
  },

  saveResumeModifications: async (params = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'resume/update',
      params: params,
      isFile: false
    });
    return responseHandler(response);
  },

    saveCandidateModifications: async (params = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'resume/updateCandidate',
      params: params,
      isFile: false
    });
    return responseHandler(response);
  },

  getSectors: async (params = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'sectors',
      params: params,
      isFile: false
    });
    return responseHandler(response);
  },

  getLanguages: async (params = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'languages',
      params: params,
      isFile: false
    })
    return responseHandler(response);
  },

  getNationalities: async (params = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'countries',
      params: params,
      isFile: false
    });
    return responseHandler(response);
  },

  getSubSectors: async (params = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'sub_sectors',
      params: params,
      isFile: false
    });
    return responseHandler(response);
  },

  getLanguageLevels: async (params = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'language_levels',
      params: params,
      isFile: false
    });
    return responseHandler(response);
  },
  getExperienceLevels: async (params = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'experience_intervals',
      params: params,
      isFile: false
    });
    return responseHandler(response);
  },

  getProjectPhases: async (params = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'project_phases',
      params: params,
      isFile: false
    });
    return responseHandler(response);
  },

  getEducationLevels: async (params = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'education_levels',
      params: params,
      isFile: false
    });
    return responseHandler(response);
  },

  getCountryCodes: async (params = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'country_codes',
      params: params,
      isFile: false
    });
    return responseHandler(response);
  },

  getTechnicalDisciplines: async (params = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'disciplines',
      params: params,
      isFile: false
    });
    return responseHandler(response);
  },

  getActivities: async (params = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'activities',
      params: params,
      isFile: false
    });
    return responseHandler(response);
  },

  getCountryGuid: async (params = {}) => {
    console.log("inside the guid")
    const response = callApi({
      method: 'POST',
      endpoint: 'country_guid',
      params: params,
      isFile: false
    });
    return responseHandler(response);
  },

  createCandidateUser: async (params = {}) => {
    console.log("inside create user api", params)
    const response = callApi({
      method: 'POST',
      endpoint: 'create_candidate_user',
      params: params,
      isFile: false
    });
    return responseHandler(response);
  },
  validateCandidateUser: async (key, params = {}) => {
    console.log("inside create user api", params)
    const response = callApi({
      method: 'GET',
      endpoint: `auth/activate_candidate?key=${key}`,
      params: params,
      isFile: false
    });
    return responseHandler(response);
  },
  fetchAlljobs: async (params = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'all_jobs',
      params: params,
      isFile: false
    });
    return responseHandler(response);
  },
  fetchAppliedjobs: async (params = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'candidate_applications',
      params: params,
      isFile: false
    });
    return responseHandler(response);
  },
  applyJobs: async (params = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'apply_jobs',
      params: params,
      isFile: false
    });
    return responseHandler(response);
  },
  fetchRecommendedjobs: async (params = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'job_recomendations',
      params: params,
      isFile: false
    });
    return responseHandler(response);
  },
  fetchAlljobsDropdown: async (params = {}) => {
    const response = callApi({
      method: 'GET',
      endpoint: 'all_jobs_dropdown',
      params: params,
      isFile: false
    });
    return responseHandler(response);
  },
 deleteCandidate: async (params = {}) => {
    const response = callApi({
      method: 'DELETE',
      endpoint: `delete_candidate/${params}`,
      params: '',
      isFile: false
    });
    return responseHandler(response);
  },
   candidateIdView: async (params = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'candidate_jd_view',
      params: params,
      isFile: false
    });
    return responseHandler(response);
  },
   jobSectors: async (params = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'sectors',
      params: params,
      isFile: false
    });
    return responseHandler(response);
  },
  jobCountries: async (params = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'countries',
      params: params,
      isFile: false
    });
    return responseHandler(response);
  },
  userConsent: async (params = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'update_consent',
      params: params,
      isFile: false
    });
    return responseHandler(response);
  },
}